import React, { Component } from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

class Banner extends Component {
	render() {
		return (
			<section className="faq">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-4">
							<h1 className="faq__title">Need <br /> &nbsp; &nbsp; &nbsp; &nbsp; Help?</h1>
							<p>We promise we'll be there for you, no matter what. <br /> <br /> You can reach out to us anytime on support@lovefromyours.com or on Whatsapp.
							</p>
							<a href="">READ MORE</a>
						</div>
						<div className="col-md-8 faq__content">
							<h5>FAQs</h5>
							<div className="accordion" id="faq">
								<Accordion>
									<AccordionItem>
										<div className="card">
							                <AccordionItemHeading>
							                    <AccordionItemButton>
													<div className="card-header">
														<h2 className="mb-0">
														Are your products Paraben, Sulfate and Phthalate-free?
														</h2>
													</div>
												</AccordionItemButton>
											</AccordionItemHeading>
											<AccordionItemPanel>
												<div className="card-body">
													Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
												</div>
											</AccordionItemPanel>
										</div>
										</AccordionItem>
										<AccordionItem>
										<div className="card">
							                <AccordionItemHeading>
							                    <AccordionItemButton>
											<div className="card-header">
												<h2 className="mb-0">Are your products Paraben, Sulfate and Phthalate-free?</h2>
											</div>
											</AccordionItemButton>
											</AccordionItemHeading>
											<AccordionItemPanel>
												<div className="card-body">
													Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
												</div>
											</AccordionItemPanel>
										</div>
										</AccordionItem>
										<AccordionItem>
										<div className="card">
							                <AccordionItemHeading>
							                    <AccordionItemButton>
											<div className="card-header">
												<h2 className="mb-0">Are your products Paraben, Sulfate and Phthalate-free?</h2>
											</div>
											</AccordionItemButton>
											</AccordionItemHeading>
											<AccordionItemPanel>
												<div className="card-body">
													Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
												</div>
											</AccordionItemPanel>
										</div>
										</AccordionItem>
										<AccordionItem>
										<div className="card">
							                <AccordionItemHeading>
							                    <AccordionItemButton>
											<div className="card-header">
												<h2 className="mb-0">Are your products Paraben, Sulfate and Phthalate-free?</h2>
											</div>
											</AccordionItemButton>
											</AccordionItemHeading>
											<AccordionItemPanel>
												<div className="card-body">
													Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
												</div>
											</AccordionItemPanel>
										</div>
										</AccordionItem>
								</Accordion>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}


export default Banner;